var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiSmilingFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3512 12.1293C11.249 10.6234 11.5267 9.18006 10.9644 8.29901C10.6914 7.87124 10.2309 7.61139 9.73854 7.59286C9.30505 7.57655 8.86465 7.74768 8.52071 8.12281C8.06921 7.88794 7.59683 7.87775 7.19507 8.04135C6.73873 8.22716 6.39488 8.62884 6.28465 9.12419C6.05761 10.1444 6.81225 11.4056 9.11063 12.1717C9.19284 12.1991 9.28332 12.1831 9.3512 12.1293Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8895 12.1717C17.1878 11.4057 17.9425 10.1444 17.7154 9.12418C17.6052 8.62883 17.2613 8.22715 16.805 8.04134C16.4032 7.87775 15.9309 7.88793 15.4794 8.1228C15.1354 7.74767 14.695 7.57654 14.2615 7.59286C13.7692 7.61139 13.3087 7.87124 13.0356 8.29901C12.4734 9.18006 12.7511 10.6234 14.6489 12.1293C14.7168 12.1832 14.8073 12.1991 14.8895 12.1717Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 17.9998C14.0202 17.9998 15.6915 16.5001 15.9607 14.5525C16.0013 14.2589 15.7421 14.0265 15.4469 14.0528C13.1377 14.2586 10.8594 14.2586 8.55023 14.0528C8.25498 14.0265 7.99585 14.2589 8.03643 14.5525C8.30561 16.5001 9.97695 17.9998 11.9986 17.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmilingFace);
export default __webpack_public_path__ + "static/media/emoji-smiling-face.b3ff66135e68c4d4a3b081d1caa1ec0c.svg";
export { ForwardRef as ReactComponent };